'use strict'

const eControl = {}

eControl['y/n'] = {}
eControl['y/n']['0'] = 'No'
eControl['y/n']['1'] = 'Yes'
eControl['y/n']['F'] = 'No'
eControl['y/n']['T'] = 'Yes'

// roof credit options
eControl['roofCredit'] = {}
eControl['roofCredit']['NONE'] = 'None'
eControl['roofCredit']['RDNT_BARRIER'] = 'Radiant Barrier'
eControl['roofCredit']['COOLROOF'] = 'Cool Roof'

// addition HVAC options
eControl['hvacExtnRepl'] = {}
eControl['hvacExtnRepl']['EXTN_GAS'] = 'Extend Existing HVAC Gas System'
eControl['hvacExtnRepl']['EXTN_HEATPUMP'] = 'Extend Existing HVAC Heatpump System'
eControl['hvacExtnRepl']['REPLACE'] = 'Replace Old HVAC System'
eControl['hvacExtnRepl']['ADD'] = 'Add New HVAC System to the Addition'

// addition water heater strategy
eControl['watrHetrExtnRepl'] = {}
eControl['watrHetrExtnRepl']['EXTEND'] = 'Extend Water Heating System'
eControl['watrHetrExtnRepl']['REPLACE'] = 'Replace Water Heater'
eControl['watrHetrExtnRepl']['ADD'] = 'Add New Water Heaters, keep existing one(s)'
eControl['watrHetrExtnRepl']['ADDREPLACE'] = 'Add New Water Heaters, replace existing one(s)'

// addition solar assist
eControl['solarAssist'] = {}
eControl['solarAssist']['NONE'] = 'None'
eControl['solarAssist']['ACTIVE'] = 'Active'
eControl['solarAssist']['PASSIVE'] = 'Passive'

// addition net solar fraction
eControl['netSolarFract'] = {}
eControl['netSolarFract']['35'] = '35%'
eControl['netSolarFract']['50'] = '50%'

// perimeter labels
eControl['perim'] = {}
eControl['perim']['EXS'] = 'Pre-existing Perimeter Length'
eControl['perim']['COV'] = 'Length Covered By Addition'
eControl['perim']['ADN'] = 'Addition Perimeter Length'

// addition other walls
eControl['wallAdtn'] = {}
eControl['wallAdtn']['EXS'] = 'Existing Wall to Remain'
eControl['wallAdtn']['COV'] = 'Existing Wall Removed or Covered by Addition'
eControl['wallAdtn']['ADN'] = 'New Wall for Addition'
eControl['wallAdtn']['UPD'] = 'Existing Wall Upgraded to Addition Level'

// Wall Blower Door Test
eControl['blowerDoorTest'] = {}
eControl['blowerDoorTest']['NONE'] = 'None'
eControl['blowerDoorTest']['TIGHT'] = 'Tight (2.8 SLA)'
eControl['blowerDoorTest']['EXTIGHT'] = 'Extremely Tight (1.5 SLA)'

export default eControl



// WEBPACK FOOTER //
// ./src/app/project-report/additional-controls.js